import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Hubspot: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} width={size ?? '21'} height={size ?? '21'} fill="none" viewBox="0 0 21 21" data-testid="hubspot-icon">
      <path
        fill={color ?? '#f95c35'}
        style={{
          stroke: 'none',
          fillRule: 'nonzero',
          fillOpacity: 1,
        }}
        d="M15.256 15.133c-1.627 0-2.946-1.258-2.946-2.81 0-1.553 1.319-2.811 2.946-2.811 1.626 0 2.945 1.258 2.945 2.81 0 1.553-1.319 2.81-2.945 2.81m.881-8.22v-2.5c.684-.309 1.163-.969 1.163-1.735v-.058c0-1.057-.906-1.922-2.015-1.922h-.06c-1.108 0-2.014.865-2.014 1.922v.058c0 .766.479 1.426 1.163 1.735v2.5a5.85 5.85 0 0 0-2.716 1.14l-7.194-5.34c.047-.173.08-.353.081-.54C4.546.973 3.531.001 2.275 0 1.02-.001.001.968 0 2.166c-.001 1.197 1.014 2.17 2.27 2.171.409 0 .787-.11 1.119-.29L10.465 9.3a5.28 5.28 0 0 0-.954 3.022c0 1.17.387 2.253 1.042 3.143L8.4 17.52a1.921 1.921 0 0 0-.534-.083c-1.03 0-1.867.798-1.867 1.782S6.836 21 7.867 21c1.032 0 1.868-.798 1.868-1.782 0-.178-.036-.347-.087-.509l2.129-2.031a5.893 5.893 0 0 0 3.479 1.126c3.172 0 5.744-2.454 5.744-5.482 0-2.74-2.11-5.004-4.863-5.41"
      />
    </svg>
  );
};

export default Hubspot;
